export default __webpack_public_path__ + "static/Group 1292-ce3fb4a1f737f5d23033caee5e10da5d.png";